import type { FunctionComponent } from 'react';

import MultiKeyValue from '../../../../components/fields/multi_key_value/multi_key_value';
import {
  type FieldWrapperProps,
  FormContextConsumer,
} from '../../form_context/form_context';
import formField, { pickProps } from '../../form_field/form_field';

const componentProps = [
  'labelPlaceholder',
  'valuePlaceholder',
  'autofillValue',
  'isSortable',
  'keyItemComponent',
] as const;

const Field = formField(MultiKeyValue, {
  defaultValue: [],
  transformProps: (props) => pickProps(props, componentProps),
});

export type MultiKeyValueFieldWrapperProps = FieldWrapperProps<typeof Field>;

const MultiKeyValueFieldWrapper: FunctionComponent<
  MultiKeyValueFieldWrapperProps
> = (props) => (
  <FormContextConsumer>
    {(context) => <Field {...props} {...context} />}
  </FormContextConsumer>
);

export default MultiKeyValueFieldWrapper;
